var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button synth-key",style:(_vm.style),attrs:{"data-note":_vm.note,"data-freq":_vm.frequency}},[_c('div',{staticClass:"synth-key-inner"},[_c('div',{staticClass:"synth-key-label"},[_vm._v(_vm._s(_vm.note))])])])}
var staticRenderFns = []

export { render, staticRenderFns }